export const CURRENT_POLICY_VERSION =
  process.env.REACT_APP_POLICY_VERSION || "2026-03-25";

export const PRIVACY_CONTACT_EMAIL =
  process.env.REACT_APP_PRIVACY_CONTACT_EMAIL ||
  "privacy@ravidassiaabroad.com";

export const SUPPORT_CONTACT_EMAIL =
  process.env.REACT_APP_SUPPORT_EMAIL || "ravidassiaabroad@gmail.com";

export const LEGAL_PATHS = {
  privacy: "/privacy-policy",
  terms: "/terms-of-use",
  guidelines: "/community-guidelines",
  dataRequest: "/privacy-data-request",
};

export const GENERAL_COLLECTION_NOTICE =
  "We collect the information in this form to review your request, contact you about it, and manage related admin processing on Ravidassia Abroad. Your information may be viewed by authorized admins and processed using our service providers. Please do not submit information you do not want us to store. See our Privacy Policy for details.";

export const CONNECT_SCST_CONSENT =
  "I consent to Ravidassia Abroad collecting and using the information in this form, including my contact details and supporting proof, to review my SC/ST community request, contact me about it, and store it for admin processing.";

export const MATRIMONIAL_CONSENT =
  "I expressly consent to Ravidassia Abroad collecting, storing, and using the information and photo in this biodata form for matrimonial profile review, listing display according to my selected privacy settings, and related admin processing. I understand I can later request correction, hiding, or deletion subject to platform rules and legal requirements.";

export const GUEST_COMMENT_CONSENT =
  "I consent to the use of my name, email, and comment for moderation, publication, and comment management.";

export const CONTENT_REQUEST_CONSENT =
  "I consent to the use of my contact details and request details to review and respond to this content request.";

export const SIGNUP_ACKNOWLEDGMENT =
  "I agree to the Terms of Use and acknowledge the Privacy Policy.";

export const MARKETING_OPT_IN_LABEL =
  "I want to receive promotional or community updates by email.";
